module.exports = __webpack_public_path__ + "img/KUCE-CROP-04.22a87482.png";